import { useContext } from "react";
import {
  EnvironmentalDataContext,
  MeteoInfoDataContext,
  WeatherDataContext,
  IndexesDataContext,
  AllSensorsDataContext,
  SensorTypesDataContext,
  HotSpotsDataContext,
  HydroDataContext,
  ParkingDataContext,
  MeshDataContext,
  PublicParkingDataContext,
  VariablesContext,
  MobilityContext,
  FleetDataContext,
} from "./context";
import {} from "./MobilityProvider";

export const useAllContexts = () => {
  const environment = useContext(EnvironmentalDataContext);
  const meteo = useContext(MeteoInfoDataContext);
  const weather = useContext(WeatherDataContext);
  const indexes = useContext(IndexesDataContext);
  const allSensors = useContext(AllSensorsDataContext);
  const sensorTypes = useContext(SensorTypesDataContext);
  const hotSpots = useContext(HotSpotsDataContext);
  const hydro = useContext(HydroDataContext);
  const parking = useContext(ParkingDataContext);
  const publicParking = useContext(PublicParkingDataContext);
  const mesh = useContext(MeshDataContext);
  const variables = useContext(VariablesContext);
  const mobility = useContext(MobilityContext);
  const fleeto = useContext(FleetDataContext);

  return {
    environment,
    meteo,
    weather,
    indexes,
    allSensors,
    sensorTypes,
    hotSpots,
    hydro,
    parking,
    mesh,
    publicParking,
    variables,
    mobility,
    fleeto,
  };
};
